import {Component} from '@angular/core';
import {NavController, NavParams, ModalController, ViewController} from 'ionic-angular';
import {Storage} from '@ionic/storage';
import {UserAddress} from "../../app/classes/user_address";
import {AddAddressPage} from './add_address';
import {USER_ADDRESS_STORAGE} from "../../app/constants/storage";
import {StorageService} from "../../app/services/storage.service";



@Component({
  selector: 'page-address',
  templateUrl: 'address.html'
})
export class AddressPage {
  public addresses: UserAddress[] = [];
  public mode : string;

  constructor(private storage: StorageService,
              public modalCtrl: ModalController,
              public viewCtrl : ViewController,
              public navCtrl: NavController,
              public navParams: NavParams) {
    this.storage.get(USER_ADDRESS_STORAGE).then((addresses) => {
      if (addresses)
        this.addresses = addresses;
    });

    this.mode = navParams.get('mode') || 'view';
  }



  deleteAddress(addressToDelete){
    this.addresses = this.addresses.filter((address) => {
      if (addressToDelete.identifier == address.identifier){
        return false;
      }
      return address;
    });

    this.storage.set(USER_ADDRESS_STORAGE, this.addresses);
  }

  selectAddress(address : UserAddress){
    if (this.mode == "view"){
      const modal = this.modalCtrl.create(AddAddressPage, { address });
      modal.onDidDismiss((newAddress) => {
        if (!newAddress){ return; }
        this.addresses = this.addresses.map((address) => {
          return (address.identifier == newAddress.identifier) ? newAddress : address;
        });
      });
      modal.present();
    }  else {
      this.viewCtrl.dismiss({address});
    }
  }

  addAddress() {
    const modal = this.modalCtrl.create(AddAddressPage);
    modal.onDidDismiss((address) => {
      if (address) {
        this.addresses.push(address);
      }
    });
    modal.present();
  }

  isWeb(){
    return window.localStorage.getItem('isWeb') == '1';
  }

  dismiss(){
    this.viewCtrl.dismiss(false);
  }
}



// WEBPACK FOOTER //
// ./src/pages/address/address.ts